import React from "react";
import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";

const FormActions = (props) => {
  const { children } = props;

  const style = {
    flexDirection: "row",
    padding: "24px 24px 24px 16px",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
  };

  return <Stack sx={style}>{children}</Stack>;
};

FormActions.propTypes = {
  children: PropTypes.any.isRequired,
};

export default FormActions;
